/** 用户协议 */
<template>
  <div class="home protocol-home">
    <Header class="protocolYeyun-header"  />
    <div class="protocol-contnet">
			<div class="protocol-detail">
				<h1 class="protocol-title">《代缴税款协议书》</h1>
				<p class="v3"><strong>提示：</strong></p>
				<p class="v3 v4">我方与以下第三方平台合作，委托其提供共享经济综合服务，包括但不限于为我方筛选适合的用户（以下简称为“您”），并依照主管税务机关授予的代征权限向您征收个人生产经营所得税税款等服务。 </p>
				<p class="v3"><strong>个人信息：</strong></p>
				<p class="v3 v4">您同意我方为实现服务之目的，对于获取的您的个人信息（包括但不限于自然人姓名、身份证号、手机号、收款账户信息等）可以留存使用并授权给第三方平台使用。我方承诺对您的个人隐私信息进行保密，承诺按照相关法律法规的要求，对获得的个人信息履行安全保护义务。</p>
				<p class="v2 v4" >以下为需要与第三方平台“湖南润垚信息科技服务有限公司”签订的《自由职业者服务协议》，请仔细阅读。</p>
				<h2 class="protocol-title subtitle">自由职业者服务协议</h2>
				<p class="v3"><strong>提示条款：</strong></p>
				<p class="v3 v4">欢迎您与我司（甲方）签署本《自由职业者服务协议》（下称“本协议”）并为我司提供综合服务。</p>		
				<p class="v3 v4"><strong>【审慎阅读】<u>为维护您的自身权益，在您点击同意或书面签署本协议之前，请认真阅读.本协议，务必审慎阅读、充分理解各条款内容，特别是权利义务条款、法律适用和管辖条款.上述条款以粗体及下划线标识，您应重点阅读。</u></strong></p>
				<p class="v3 v4"><strong>【签约】<u>当您按照提示填写您的个人信息、阅读并同意本协议且完成全部申请或书面签署后，即表示您已充分阅读、理解并接受本协议的全部内容，并与我司达成一致意见并成为我司的合作人员，此后您不得以未阅读/不理解本协议内容或类似言辞做任何形式的抗辩。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，请您立即停止任何的申请/注册/或书面签署程序。</u></strong></p>
				<p class="v3 v4"><strong>特别声明：</strong></p>
				<p class="v3 v4">本协议项下的自由职业者（即您）仅限于从事生产经营活动的个体工商业者，如您与我司提供综合服务的合作公司（以下简称“合作公司”）存在劳动关系、劳务关系、雇佣关系、劳务派遣、人力资源外包、关联方外派/委派或其他类似劳动人事法律关系或您担任合作公司（含关联方）的法定代表人、股东、董事、监事等，则您不能承揽我司为满足该合作公司的业务需求而发布的任务。</p>
				<p class="v3 v4">您与我司通过本协议建立合作关系，适用《中华人民共和国合同法》、《中华人民共和国民法总则》和其他民事法律，不适用《中华人民共和国劳动合同法》。</p>
				<p class="v3 v4">一经发现违反上述规定行为的，我司有权取消您为我司提供服务的资格，并有权上报相关国家机关，由相关国家机关根据《中华人民共和国税收征收管理法》及其他相关法律法规的规定追究责任主体的法律责任。</p>
				<p class="v3"><strong>协议条款：</strong></p>
				<p class="v3 v4">根据国家法律有关规定，双方按照平等自愿、诚实信用的原则，就由您为合作公司提供对应服务事宜订立本服务合作协议。</p>
				<p class="v2"> <strong>第一条 服务工作内容</strong></p>
				<p class="v3">1.1 根据我司与合作公司签订的综合服务协议，特选用您按照综合服务协议约定的工作内容提供相应的服务。</p>
				<p class="v3">2.2 您应按照我司与合作公司签订的综合服务协议的规定的标准完成工作。</p>
				<p class="v3">3.3 您承诺和保证，您具有提供本协议服务所对应的相应资质和专业能力，您依据本协议约定收取相关费用不违反任何法律法规和政策规定。若依据相关规定，您提供的相关服务和收费，应通过所在机构或以其他法律规定的方式进行，则您自行负责办理全部事宜，若因您的自身原因未办理前述事宜，则您应承担由此引起的全部法律后果，并赔偿由此给我司及合作公司造成的全部经济损失。</p>
				<p class="v2"> <strong>第二条 协议效力</strong></p>
				<p class="v3"><u>1.1 您的签约信息（包括您的姓名、身份证号等信息），以您提供的信息为准（包括但不限于线上提供或线下提供）。您承诺并保证您所提供的签约信息真实、准确，以免影响您和我司之间的《自由职业者服务协议》效力。本协议条款若在我司授权的网站上发布，自您线上点击确认之日起生效；若为书面签署，自您签署本协议之日起生效。</u></p>
				<p class="v3">2.2 本协议自签订之日起一年有效。期限届满，双方应另行签署新的协议；若双方未签署新的协议，而以实际行动继续合作的，视为双方同意协议期限顺延直至按照本协议约定终止或解除时为止。</p>
				<p class="v2"> <strong>第三条 我司的权利和义务</strong></p>
				<p class="v3"><u>1.1 您应根据我司的安排为合作公司服务，服务期间您应遵守合作公司有关服务内容、服务质量等方面的要求。合作公司可根据自身的运营要求制定具体工作安排，您应予遵守。我司有权委托其关联企业或其授权机构负责本协议具体事务的履行，您对此表示认可且全力配合。</u></p>
				<p class="v3">2.2 我司将按合作公司的相关规定与合作公司共同对您为合作公司提供服务的工作成果进行验收。</p>
				<p class="v3"><u>3.3 我司应按约定及时向您支付费用。此处您应明确：您作为我司的合作人员，在合作公司正常向我司结算情况下，您的相关费用结算将由我司完成支付，您不应向合作公司或其关联公司主张任何费用。您通过合作公司渠道发起的提现/或任何申请支付的行为，均视为向我司发起，而并非向合作公司或其关联公司发起。</u></p>
				<p class="v3"><u>4.4 您同意，您不可撤销地授权我司和合作公司有权为提供前述费用结算服务的需要获取您的相关信息（包括但不限于个人身份信息、实名登记手机号码、银行账户相关信息等），并将您的相关信息提交第三方机构进行身份验证。若您提供任何错误、虚假、失效或不完整的资料，或者我司或合作公司有合理的理由怀疑资料为错误、虚假、过期或不完整，我司或合作公司有权暂停或终止向您提供部分或全部服务，对此我司或合作公司不承担任何责任，您承诺并同意负担因此所产生的所有损失，包括但不限于直接损失、间接损失。若因国家法律法规、部门规章或监管机构的要求，我司或合作公司需要您补充提供任何相关资料时，如您不能及时配合提供，我司或合作公司有权暂停或终止向您提供部分或全部服务。</u></p>
				<p class="v2"> <strong>第四条 您的权利和义务</strong></p>
				<p class="v3">1.1 您保证签署本协议时具有完全民事权利能力和民事行为能力或系已满十六周岁未满  十八周岁经法定监护人同意的民事主体，并满足所有履行本协议所需的法定条件或约定条件， 如因您个人原因造成您本人或任意第三方损害的，由您承担全部法律责任。您应按时尽责地 完成我司以及合作公司要求的工作内容，并达到规定的质量标准，不得有侵犯他人知识产权、财产权、人身权、肖像权、隐私权、商业秘密或其他合法权益以及其他违反国家法律法规、 国家政策、或有悖于公序良俗的内容。</p>
				<p class="v3"><u>2.2 协议期内，您应在我司以及合作公司许可范围内使用本协议有关的商业信息；协议期内以及协议终止后，您均有义务对双方合作的有关协议及合作过程中知悉的我司、合作公司的相关信息予以保密，未经书面许可，您不得以任何方式向其它方披露、给予或转让该等保密信息。否则，因此导致我司及/或合作公司或其关联公司的损失，由您负责赔偿。</u></p>
				<p class="v3">3.3 除本协议事项外，您不能以我司及/或合作公司的名义开展任何与完成约定的工作任务无关的业务或活动。</p>
				<p class="v3">4.4 若相关服务通过合作公司指定的网络平台提供，或者合作公司指定的相关网络平台备案，合作公司指定的网络平台可能将要求您签署、点击电子协议，您同意点击签署。您点击确认后该协议将对您产生法律效力。</p>
				<p class="v3">5.5 若您被我司的合作公司推荐给第三方提供服务，已知与其存在事实或者法律上的人事劳动关系，您有义务告知我司并拒绝合作，若您知情未告知我司，您应承担相关责任并赔偿我司损失。</p>
				<p class="v2"> <strong>第五条  服务费用的支付及生产经营收入结算方式</strong></p>
				<p class="v3"><u>1.1 我司将根据经合作公司确认的项目服务人员服务标准及收费标准向您支付服务费用。由于您所提供的服务内容、服务质量、服务时长等情况的不同，该等服务费用金额可能会呈现浮动，您清楚并了解该等浮动为正常情况。我司以人民币形式向您支付服务费用，在向您支付生产经营收入时，有权在我司所在地向主管税务机关代您进行临时税务登记，并按照有关税收政策规定及主管税务机关的要求，向您代征增值税、附加税费、个人所得税税款等；即您应缴纳的增值税、个人所得税及其他相关税费由我司负责代扣代缴。</u></p>
				<p class="v3"><u>2.2 我司将通过【A、B、C】账户向您支付上述服务费用。<p>A．银行</p><p>B．支付宝</p><p>C．微信</p>您应向我司提供以您本人实名注册的对应账户信息，以及相关必要的证件。若具体账户信息在指定的网络平台在线提供的，以您在线提供的信息为准，如信息发生变更应及时通知我司，否则因此造成的一切不利后果由您承担。</u></p>
				<p class="v3">3.3 我司服务费用支付以您提供的收款账户为准，因您提供的收款账户不实造成的一切损失由您自行承担。 如您账户变更或发生不可用等情况时，应及时书面通知我司或在合作公司指定的网络平台进行变更操作，否则，由此造成的一切损失由您自行负责。</p>
				<p class="v3">4.4 根据我司与合作公司签署的《综合服务协议》的约定，我司基于合作公司业务需求所对应的活动内容及费用标准向合作公司提供综合服务并收取服务费。我司收到合作公司支付的服务费后，将根据您任务完成的数量和质效核算、支付您的生产经营收入。</p>
				<p class="v3">5.5 您应自行负担就您取得的生产经营收入需缴纳的各项税费，应我司要求，您应提供申报缴纳税费的相关协助及信息；我司承诺依法代征增值税、个人所得税及其他税费并确保您取得税后合法收入。</p>
				<p class="v3"><u><strong>6.6 我司不承担您任何社保福利待遇，也不负责您的任何医疗保险费用。</strong></u></p>
				<p class="v2"> <strong>第六条 知识产权条款</strong></p>
				<p class="v3">1.1 本协议履行过程中所产生的全部成果（以下简称“作品”），无论协议因何原因提前终止，您已完成的且经甲方的合作公司认可的作品的著作权及其衍生的知识产权，均由合作公司自行享有，合作公司有权自行或许可任意第三人自由且不受任何限制的使用，不需另行征得您的同意及向您支付其他任何费用。</p>
				<p class="v3">2.2 合作公司有权自行或许可、委托任意第三人根据作品进行再创作、改编等行为，再创作或改编形成的课程、视频、音频等成果（不限于上述成果）的著作权及衍生的知识产权均由合作公司自行享有，合作公司有权自行或许可任意第三人自由且不受任何限制的使用，无需另行征得您的同意及向您支付其他任何费用。</p>
				<p class="v3">3.3 在本协议履行过程中，合作公司为完成服务项目工作而向您交付的全部资料（如商标、版权、专利、图纸、技术资料等不限于）、文件的著作权及所有权均仍为合作公司，并不因 本协议的履行而产生任何的变动。合同履行完毕或提前终结的，您应立即将甲方交付资料、 文件（实体文件）返还合作公司，或将所有资料、文件（包括电子版）自行销毁。未经合作 公司许可，您不得用作本协议目的之外的任何用途，并不得故意、过失致使第三人知悉。</p>
				<p class="v3">4.4 在本协议履行过程中，您为完成服务项目工作而采用的资料、文件、素材均应已获得相关著作权人的许可，不存在侵犯任何第三人权利的情况存在，否则，您需承担因此而给合作公司造成的全部损失。</p>
				<p class="v3">5.5 未经合作公司书面许可或委托，您不得以任何方式使用作品，不得以作品所涉及的任何素材（包括但不限于人物、道具、世界观、背景、大纲等）进行任何再创作，包括但不限于改写、续写、重写，姊妹篇、番外、同人、人物传等。</p>
				<p class="v3">6.6 如违反本条款（即第六条）约定的，您应全额返还已收取的全部费用，按照不低于【伍】万元的标准承担违约金，并承担因此而给合作公司造成的全部损失。</p>
				<p class="v3">7.7 本条款永久有效，并不因本协议终结而失效。</p>
				<p class="v2"> <strong>第七条 违约责任</strong></p>
				<p class="v3">1.1 双方应按本协议约定履行，如有违反，守约方有权要求对方及时改正；造成对方损失的，守约方有权要求违约方赔偿。</p>
				<p class="v3">2.2 因不可抗力造成损失的，彼此不负赔偿责任，但发生不可抗力一方应及时将有关情况通知另一方，并尽最大努力进行补救。本协议所称不可抗力是指不能预见、不能克服并不能避免且对一方当事人造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、火灾和风暴等以及社会事件如战争、动乱、政府行为、黑客事件、大范围电信事故等。</p>
				<p class="v2"> <strong>第八条 通知</strong></p>
				<p class="v3">除本协议另有约定外，在履行本协议过程中的一切通知，我司可通过网页公告、电子邮件、系统通知、短信提醒、微信小程序、电话或其他合理方式向您送达，该等通知于发送之日视为已送达收件人。</p>
				<p class="v2"> <strong>第九条 协议的终止</strong></p>
				<p class="v3">1.1 发生以下情形时，本协议终止：
					<p class="v3">a. 协议期限届满或任何一方提前 30 日书面通知对方要求终止协议的，但您要求终止协议应事先获得合作公司的同意并不得影响合作公司的运营；</p>
					<p class="v3">b. 一方违反协议约定，且违约方在非违约方书面通知后 15 日内仍未予改正的，非违约方可以书面通知的形式终止本协议；</p>
					<p class="v3">c. 我司有合理理由或有证据认定您违反本协议或相关法律法规及社会公序良俗，包括但不限于涉嫌传销、洗钱、赌博、暴力、淫秽、恐怖、偷逃骗税行为等；</p>
					<p class="v3">d. 我司有合理理由或有证据认定您存在危害国家统一、颠覆国家政权、损害国家荣誉和利益、破坏民族团结的行为或发表前述相关言论的；</p>
					<p class="v3">e. 您如未能达到我司的要求，我司在工作验收时将给予警告；此后继续发生类似情况的；</p>
					<p class="v3">f. 其他原因导致本协议无法继续履行的；</p>
				</p>
				<p class="v3">2.2 本协议在发生下列情形时自然终止：
					<p class="v3"><strong>a. 经合作公司事先同意的情况下，您主动退出服务的；</strong></p>
					<p class="v3"><strong>b. 合作公司终止或变更业务模式而不需要您继续履行本协议的；</strong></p>
					<p class="v3"><strong>c. 合作公司认为您不适合继续提供服务的；</strong></p>
					<p class="v3"><strong>d. 我司和合作公司解除合作的；</strong></p>
					<p class="v3"><strong>e. 其他原因导致本协议不再继续履行的；</strong></p>
					<p class="v3">3.3 本协议的提前终止不影响已经产生的权利义务关系。</p>
					<p class="v2"> <strong>第十条 涉税事务委托授权</strong></p>
					<p class="v3">1.1 您/本人委托我司代理本协议交易项下的涉税事务，包括代理报税、代开发票和代开个人完税证明。</p>
					<p class="v3">2.2 您/本人确认我司根据本协议授权提交的相关申报资料和信息是真实、完整、准确， 符合有关法律法规的。</p>
					<p class="v3">3.3 您/本人确认与我司的合作公司不存在法律上和事实上的人事劳动关系，不属于合作公司人事管理权限范围内的个人，也并非其股东。</p>
					<p class="v2"> <strong>第十一条 其他</strong></p>
					<p class="v3"><u><strong>1.1  因履行本协议发生的纠纷，双方应友好协商解决，协商不成的，提请我司所在地人民法院诉讼解决。</strong></u></p>
					<p class="v3">2.2 我司有权根据业务需要，在法律允许的范围内修改本协议条款。</p>
				</p>
				<p class="v2 v4" style="margin-top: 150px;">以下为需要与第三方平台“薇鼎信息技术有限公司”签订的《薇链®平台服务商合作协议》，请仔细阅读。</p>
				<h2 class="protocol-title subtitle">薇链®平台服务商合作协议</h2>
				<p class="v3 v4">《薇链®平台服务商合作协议》为薇链®平台与您签订的合作协议。如您不同意本协议的内容，请不要勾选或以其他方式进行后续操作；您勾选同意本协议，即表示您已充分阅读、理解并同意接受本协议的全部内容。感谢您选择薇链®平台为您提供服务。</p>
				<p class="v3 v4">鉴于薇链®服务平台（甲方，以下称为“平台”）为平台入驻企业客户提供线上平台服务，您（乙方）系自由职业者个人，为甲方平台入驻企业客户提供相关服务。甲乙双方依据《中华人民共和国合同法》及相关法律法规的规定，本着平等、自愿、诚信的原则，在平等互利的基础上友好协商并签署本协议。</p>
				<p class="v2"> <strong>第一条 合作内容</strong></p>
				<p class="v3">1、平台依据与入驻企业签署的《平台企业服务协议》约定，乙方在甲方平台为入驻企业提供相关服务。</p>
				<p class="v3">2、乙方注册为平台用户，可在平台上获取企业客户的项目需求，并需按照企业客户的要求完成相应任务。待企业客户对乙方提供的服务效果和数量进行验收确认并支付相应服务费后，甲方将乙方的经营收益（以下称为：任务服务费）结算给乙方。</p>
				<p class="v3">3、乙方所提供的服务非经纪代理、介绍服务，甲乙双方不产生劳动、劳务关系。</p>
				<p class="v2"> <strong>第二条 经营所得的结算及支付方式</strong></p>
				<p class="v3">1、依据与企业公司签署的《平台企业服务协议》约定，甲方收到企业支付的服务费后，依据企业提供的任务验收材料，在1个工作日内为乙方结算任务服务费，并按规定为乙方代征相关税费（含：增值税、城建税、教育费附加、地方教育费附加、个人所得税、印花税等）。</p>
				<p class="v3">2、乙方自行负担就取得的经营收入需要缴纳的各项税款，按照平台要求提供与个人所得税申报缴纳相关的协助及信息。</p>
				<p class="v3">3、乙方确认并保证上述账户信息等真实、准确，如有变更，应提前10个工作日书面通知对方，因未履行通知义务造成的一切后果自行承担。</p>
				<p class="v2"> <strong>第三条 乙方的权利与义务</strong></p>
				<p class="v3">1、乙方保证签署本协议时具有完全民事权利能力和完全民事行为能力，且已满十八周岁、小于七十五周岁民事主体，并满足所有履行本协议所需的法定条件或约定条件。</p>
				<p class="v3">2、乙方在平台注册时应提供真实、有效、合法的信息，如信息发生变更应及时告知甲方。乙方的账户信息以实名提交至企业客户平台后台的信息为准。自甲方将应支付的任务服务费（税后）支付至乙方账户之日起，视为乙方已收到前述费用。如因乙方提供的信息有误导致付款失败的，由乙方承担相应责任。</p>
				<p class="v3">3、乙方需按照业务规则为企业客户提供相关服务，并自行准备所需材料、自行承担必要费用。乙方承诺使用平台行为及为企业公司提供服务的所有行为遵守法律、法规、行政规章和平台的相关规定以及各种社会公共利益或公共道德，如因乙方个人原因造成的乙方、企业客户或任意第三方损害的，由乙方自行承担全部法律责任。</p>
				<p class="v3">4、乙方自行保管在甲方平台的账号和密码，且须对在账号密码下发生的所有活动承担责任；如因乙方原因泄露账号密码信息并对乙方、平台或第三方造成损害，由乙方承担全部法律责任。乙方若发现任何非法使用乙方账号或有安全漏洞的情况，需立即反馈给甲方。</p>
				<p class="v3">5、乙方保证在提供服务过程中遵守国家法律法规，不得从事违反法律及行政法规等行为（包括但不限于涉嫌洗钱、偷税、漏税、逃税）或其他不得使用平台服务的行为，平台、企业公司主管税务机关或其他相关国家机关介入调查时，乙方需予以协助并如实反映情况，不得阻挠、拒绝调查。</p>
				<p class="v3">6、乙方承诺不存在下列所述情形：</p>
				<p class="v3 v4">（1）与企业客户具有劳动关系、劳务关系或其他类似的劳动人事法律关系；</p>
				<p class="v3 v4">（2）为企业客户的法定代表人、股东、董事、监事；</p>
				<p class="v3 v4">（3）其他不适用于本协议平台服务范围之规定的人员。</p>
				<p class="v2"> <strong>第四条 甲方的权利与义务</strong></p>
				<p class="v3">1、甲方有权敦促乙方按照企业客户提出的服务要求提供服务，但该等敦促为平等主体之间的为实现合同目的的敦促。甲方为使乙方满足企业客户的业务需求而向乙方提供的服务，不导致甲方与乙方之间构成劳动关系或劳务关系，且甲方对乙方违反法律法规的行为以及项目实施过程中甲方过错引起的人身及财产损害不承担任何法律责任。</p>
				<p class="v3">2、甲方向乙方支付任务结算费（税后）时，有权按照有关税收政策规定及要求，向甲方平台所对接的主管税务机关对乙方代征个人所得税税款。</p>
				<p class="v3">3、甲方发现乙方违反本协议第三条第6款之约定的，有权立即中止履行本协议，并向平台对接的主管税务机关报告，乙方自行承担由此产生的税务相关的处罚责任（包括但不限于补缴相应的税款、滞纳金、罚金等）。</p>
				<p class="v3">4、甲方可以留存为实现本次合作内容从企业客户或乙方获取的信息，甲方（含股东会、董事会、监事会成员及高级管理人员）应对乙方披露的个人隐私进行保密，未经乙方授权或基于合法并可执行的法律、法规、法院命令、监管机构的要求或为遵守适用法律法规、履行网络安全保护义务或应对网络安全事件的需要，甲方不得将乙方信息披露给任意第三方。若甲方违反此项规定给乙方造成的经济损失，由甲方承担全部赔偿责任。</p>
				<p class="v3">5、甲方平台因网络服务的特殊性需要短时间中断服务对系统进行维护和升级，不属于平台违约情形。</p>
				<p class="v3">6、如因企业客户与乙方之间另存服务或有其他约定安排的，甲方就未参与的项目安排不承担任何义务。</p>
				<p class="v2"> <strong>第五条 违约责任</strong></p>
				<p class="v3">1、除本协议另有约定外，本协议任意乙方不履行或不完全履行本协议约定的义务和承诺即构成违约。违约方应当负责赔偿其违约行为给守约方造成的一切经济损失（包括但不限于合理的律师费、诉讼费、公证费等）。</p>
				<p class="v3">2、因政府行为（包括但不限于因中国政府机关不授予或调整平台相应经营资质或权利）或其他不可抗力因素导致本协议部分条款或全部条款无法履行的，遭受该行为的乙方不承担违约责任。</p>
				<p class="v2"> <strong>第六条 保密责任</strong></p>
				<p class="v3">1、本协议任意一方应对本协议所涉及的所有内容以及协议双方在执行本协议过程中相关的法律、商业、合作业务的所有信息进行保密。未经对方允许，均不得向任意第三方披露。</p>
				<p class="v3">2、保密期限为：自协议生效之日起至协议终止后十年。</p>
				<p class="v2"> <strong>第七条 法律适用、争议纠纷解决</strong></p>
				<p class="v3">1、本协议的成立、生效、履行、解释及因本协议产生的任何争议，均适用中华人民共和国法律（不包括港澳台地区法律）。</p>
				<p class="v3">2、甲方和乙方之间与本协议有关的任何争议，首先应友好协商解决，在争议不能通过协商达成一致的，双方同意将前述争议提交至甲方所在地有管辖权的人民法院进行诉讼。</p>
				<p class="v2"> <strong>第八条 通知</strong></p>
				<p class="v3">除本协议另有约定外，在履行本协议过程中的一切通知，甲方可通过网页公告、系统通知、短信提醒或其他合理方式向乙方送达，通知发出之日起视为已送达收件人。</p>
				<p class="v2"> <strong>第九条 其他事项</strong></p>
				<p class="v3">1、本协议乙方入驻平台即视为生效。</p>
				<p class="v3">2、乙方注稍账号时本协议自动终止。</p>
			</div>
     </div>
    <Footer/>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Layout from '@/components/DatePanel/Layout.vue'
import BasiceLayout from '@/components/Common/BasicLayout.vue'
import { mapActions, mapState } from 'vuex'
import Footer from '@/components/Common/Footer.vue'

export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    Header,
    Layout,
    BasiceLayout,
    Footer
  },
}
</script>

<style  lang="stylus" scoped="scoped">

@media (min-width: 992px) {
  .protocol-wrap  {
      max-width: 940px!important;
  }
}

@media (min-width: 768px) {
  .protocol-wrap {
      max-width: 720px;
  }
}

@media (min-width: 544px){
   .protocol-wrap  {
    max-width: 576px;
  }
}
.protocol-title{
	text-align:center;
}

.subtitle{
		margin:40px 0;
}

.v4{
	text-indent:2rem;
}

.protocol-contnet   
  width: 50%;
  max-width: 1140px;
  text-align:left;
  margin: 40px auto 80px;
  padding-left: 15px;
  padding-right: 15px;
  text-align: justify;
  text-align: justify;
  color: #fff;
  letter-spacing: 0.5px;
  font-family: "Montserrat", Sans-serif;
  color: #ffffff;
  letter-spacing: 0.5px;
.protocol-contnet p  
  margin: 0 0 15px 0;
  font-weight: 400;
  font-size: 16px;
  color: #d1d3d6;
  font-family: "Montserrat", sans-serif;
  line-height: 1.625;
  -webkit-font-smoothing: antialiased;
.protocol-contnet  .v1
  font-size: 40px;
  margin-bottom: 30px;
  font-weight: 600;

.protocol-contnet .v2
  font-size: 18px;
  display: inline-block;
  padding: 30px 0 20px;

.protocol-contnet  .v3 
  font-weight: 400;
  font-size: 16px;
  color: #d1d3d6;
  font-family: "Montserrat", sans-serif;
  line-height: 1.625;
  -webkit-font-smoothing: antialiased;
.protocol-contnet .notice
  margin: 20px;
  padding: 5px;

.header-logo {
    width: 130px;
    height: 23.5px;
    margin: 19px 25px;
}

.header 
  width: 50%; 
  /* margin: 40px auto; */
  padding-left: 15px;
  padding-right: 15px;
  margin: 0 auto;
  text-align: left;

.protocol-home.home
  height: auto!important;
	
.protocolYeyun-header{
	width:100%;
	background-color: #000519;
}
</style>
